import React from 'react';

const Arrow = (props) => {
  if (props.type === "prev") {
    if (!props.currentSlide) {
      return null;
    }
  }

  if (props.type === "next") {
    if (props.currentSlide === (props.slideCount - 1)) {
      return null;
    }
  }

  const bc = `gallery__nav gallery__nav--${props.type}`;
  const ic = `icon icon--${props.type}`

  return (
    <a
      onClick={props.onClick}
      className={bc}
    >
      <i className={ic}></i>
    </a>
  )
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/gallery/arrow.js